import styled from 'styled-components';

export const SettingsDeviceRowOptionsStyled = styled.div`
    display: flex;
`;
